import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { useSpaceGroupsContext } from "@circle-react/contexts/spaceGroupsContext";
import { useSpacesContext } from "@circle-react/contexts/spacesContext";
import { useMemo } from "react";

export const useIsLoadingAppData = () => {
  // We want synchronise loader, while some shared resources responsible for rendering core UI are loading
  // We want to show a loader/
  const spacesContext = useSpacesContext();
  const spaceGroupsContext = useSpaceGroupsContext();
  const punditUserContext = usePunditUserContext();

  const isSpaceLoading = Boolean(spacesContext.helpers.isDataLoading());
  const isSpaceGroupLoading = Boolean(spaceGroupsContext.isLoading);
  const isPunditUserLoading = Boolean(punditUserContext.isLoading);

  return useMemo(
    () => isSpaceLoading || isSpaceGroupLoading || isPunditUserLoading,
    [isSpaceLoading, isSpaceGroupLoading, isPunditUserLoading],
  );
};
